import { fetch, getPaging, Method } from 'core/api/fetch';

const PriceGroupTabRoutes = {
    create: '/api/v1.1.1/experiencer/pricegrouptab',
    getList: (options, params) => `/api/v1.1.1/experiencer/pricegrouptab?${params}&${getPaging(options)}`,
    getById: (id) => `/api/v1.1.1/experiencer/pricegrouptab/${id}`,
    update: (id) => `/api/v1.1.1/experiencer/pricegrouptab/${id}`,
    getPriceGroups: (id, options, params) => `/api/v1.1.1/experiencer/pricegrouptab/${id}/pricegroup?${params}&${getPaging(options)}`,
};

export const PriceGroupTabService = {
    create: async (pricingData) => {
        try {
            const { data } = await fetch(PriceGroupTabRoutes.create, {
                method: Method.POST,
                authenticated: true,
                data: pricingData,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
    getList: async (options) => {
        try {
            const params = new URLSearchParams();

            if (options?.name?.length > 0) {
                params.append('name', options.name);
            }

            if (Array.isArray(options?.statusIds)) {
                options.statusIds.forEach((status) => params.append('statusIds', status?.id));
            }

            const { data } = await fetch(PriceGroupTabRoutes.getList(options, params.toString()), {
                method: Method.GET,
                authenticated: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
    getById: async (priceGroupTabId) => {
        try {
            const { data } = await fetch(PriceGroupTabRoutes.getById(priceGroupTabId), {
                method: Method.GET,
                authenticated: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },

    getPriceGroups: async (priceGroupTabId, options) => {
        try {
            const params = new URLSearchParams();

            if (options?.name?.length > 0) {
                params.append('name', options.name);
            }

            if (Array.isArray(options?.statusIds)) {
                options.statusIds.forEach((status) => params.append('statusIds', status?.id));
            }

            if (Array.isArray(options?.typeIds)) {
                options.typeIds.forEach((type) => params.append('typeIds', type?.id));
            }

            const { data } = await fetch(PriceGroupTabRoutes.getPriceGroups(priceGroupTabId, options, params.toString()), {
                method: Method.GET,
                authenticated: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },

    update: async (priceGroupTabId, pricingData) => {
        try {
            const { data } = await fetch(PriceGroupTabRoutes.update(priceGroupTabId), {
                method: Method.PATCH,
                authenticated: true,
                data: pricingData,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
};
